import apiClient from "./client.js";

export const submitProposal = (formData) =>
  apiClient.post("/proposals", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data.data);

export const getProposals = (params = {}) =>
  apiClient.get("/proposals", { params }).then((r) => r.data.data);

export const getProposal = (id) =>
  apiClient.get(`/proposals/${id}`).then((r) => r.data.data);

export const getProposalTemplateUrl = (id) =>
  apiClient.get(`/proposals/${id}/template-download`).then((r) => r.data.data);

export const acceptProposal = (id, data) =>
  apiClient.post(`/proposals/${id}/accept`, data).then((r) => r.data.data);

export const rejectProposal = (id, data) =>
  apiClient.post(`/proposals/${id}/reject`, data).then((r) => r.data.data);
